import React from 'react';
import useBundleTranslation from 'i18n';

interface KPIsAnnouncementsLayoutIconAltProps {
    width?: number;
    height?: number;
    className?: string;
}

export default function KPIsLayoutIcon({ width = 360, height = 216, className }: KPIsAnnouncementsLayoutIconAltProps) {
    const { t } = useBundleTranslation('form');

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 360 216"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect width="360" height="216" rx="4" fill="#00B4FF" fillOpacity="0.04" />
            <rect x="0.5" y="0.5" width="359" height="215" rx="3.5" stroke="#00B4FF" strokeOpacity="0.4" />

            {/* Tiles or KPIs panel */}
            <rect
                x="60.5"
                y="56.5"
                width="159"
                height="143"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="93" y="132.273">
                    {t('builder_layouts.tiles_or_kpis_panel')}
                </tspan>
            </text>

            {/* Hero Section */}
            <rect
                x="60.5"
                y="16.5"
                width="239"
                height="23"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="68" y="31.2727">
                    {t('builder_layouts.hero_section')}
                </tspan>
            </text>

            {/* Announcements panel */}
            <rect
                x="236.5"
                y="56.5"
                width="63"
                height="143"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                transform="matrix(0 -1 1 0 265 168)"
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="0" y="7.27273">
                    {t('builder_layouts.announcements')}
                </tspan>
            </text>
        </svg>
    );
}
